import { ThemeOptions } from "@mui/material";
// https://github.com/mui/mui-x/issues/1755#issuecomment-954315943
import type {} from "@mui/x-data-grid-premium/themeAugmentation";

// This partial theme exists only because pages mounted outside @climatepartner/app-shell
// (e.g. the public supplier route) get no CP ThemeProvider.

// The CP theme sets MuiButton.defaultProps.variant = "contained" globally, but DataGrid
// toolbar buttons (GridToolbarColumnsButton etc.) need variant: "text". Since MUI X v9
// restricts slotProps.button to a base type, we augment it here to allow variant.
declare module "@mui/x-data-grid-premium" {
  interface BaseButtonPropsOverrides {
    variant?: "text" | "outlined" | "contained";
  }
}

declare module "@mui/material/styles" {
  interface Mixins {
    MuiDataGrid: {
      pinnedBackground: string;
    };
  }

  interface MixinsOptions {
    MuiDataGrid?: {
      pinnedBackground: string;
    };
  }
}

export const themePalette: ThemeOptions = {
  components: {
    MuiDataGrid: {
      styleOverrides: {
        root: ({ theme }) => ({
          border: 0,
          "& .MuiDataGrid-columnSeparator": {
            opacity: "0",
          },

          "& .MuiDataGrid-columnHeader": {
            backgroundColor: theme.palette.common.white_states.main,
          },

          "& .MuiDataGrid-columnHeader:hover .MuiDataGrid-columnSeparator": {
            opacity: "1",
          },
          "& .MuiTablePagination-toolbar": { alignItems: "center" },
        }),
        cell: {
          "&:focus": {
            outline: "none",
          },
        },
      },
    },
  },
  mixins: {
    // MUI's `mixins` option can't take a theme-aware callback, so this literal is kept in sync
    // with theme.palette.common.white_states.main by hand.
    MuiDataGrid: {
      pinnedBackground: "#fff",
    },
  },
};
